import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import GeneralButton from "../../../../components/kit/GeneralButton/GeneralButton";
import InputForm from "../../../../components/kit/InputForm/InputForm";
import InputPhoneMask from "../../../../components/kit/InputPhoneMask/InputPhoneMask";
import SelectInput from "../../../../components/kit/SelectInput/SelectInput";
import { checkEmptyField } from "../../../../global/Helpers/checkEmptyField";
import { showGenderInput } from "./../../../../constants.json";
import "../index.scss";

const ClientForm = ({
  name,
  lastname,
  gender,
  phone,
  email,
  inn,
  // documentNumber,
  dateOfBirth,
  inputChangeHandler,
  handleClickPrev,
  createPatient,
}) => {
  const disabled =
    !checkEmptyField(name) ||
    !checkEmptyField(lastname) ||
    gender === -1 ||
    !checkEmptyField(phone) ||
    // !checkEmptyField(email) ||
    // !checkEmptyField(inn) ||
    // !checkEmptyField(documentNumber) ||
    !checkEmptyField(dateOfBirth);
  return (
    <div className="client-data-root">
      <div className="client-data-root__title title">Ваши контакты</div>
      <form className="client-data-root__form">
        <InputForm
          className="client-data-root__field"
          type="text"
          value={name}
          propertyName="name"
          onChange={inputChangeHandler}
          label="Имя"
        />
        <InputForm
          className="client-data-root__field"
          type="text"
          value={lastname}
          propertyName="lastname"
          onChange={inputChangeHandler}
          label="Фамилия"
        />
        {showGenderInput && (
          <SelectInput
            className="client-data-root__field"
            value={gender}
            name="gender"
            onChange={inputChangeHandler}
            label="Пол"
          >
            <MenuItem value={-1}>Не выбран</MenuItem>
            <MenuItem value={1}>Мужской</MenuItem>
            <MenuItem value={0}>Женский</MenuItem>
          </SelectInput>
        )}
        <InputPhoneMask
          className="client-data-root__field"
          value={phone}
          propertyName="phone"
          onChange={inputChangeHandler}
        />
        {/* <InputForm
          className="client-data-root__field"
          type="email"
          value={email}
          propertyName="email"
          onChange={inputChangeHandler}
          label="Email"
        /> */}
        {/* <InputForm
          className="client-data-root__field"
          type="text"
          value={inn}
          propertyName="inn"
          onChange={inputChangeHandler}
          label="ИНН"
        /> */}
        {/* <InputForm
          className="client-data-root__field"
          type="text"
          value={documentNumber}
          propertyName="documentNumber"
          onChange={inputChangeHandler}
          label="Номер документа"
        /> */}
        <InputForm
          className="client-data-root__field birth-date"
          type="date"
          value={dateOfBirth}
          propertyName="dateOfBirth"
          onChange={inputChangeHandler}
          label="Дата рождения"
        />
      </form>
      <div className="d-flex mt-30">
        <GeneralButton
          className="mr-10"
          title="Назад"
          onClick={handleClickPrev}
        />
        <GeneralButton
          title="Далее"
          disabled={disabled}
          onClick={createPatient}
        />
      </div>
    </div>
  );
};

export default ClientForm;
